import { ia, iaRa } from 'lib/helpers/utility';

import { DateRangeContent } from 'components/shared/DateRangeSelector/DateRangeSelector';

import DropdownList from '../components/DropdownList';

const components = {
  dropdown: DropdownList,
  dateRange: (props) => (
    <DateRangeContent
      className="absolute -top-[16px] left-0 z-10 mt-2 flex w-fit overflow-hidden rounded-[4px] bg-white shadow-xs"
      {...props}
    />
  )
};

export const getFilterComponent = (type) => {
  return components[type];
};

export const getActiveFilters = (filters) => {
  if (!filters) return [];
  return Object.entries(filters);
};

export const multipleArrayOptions = ['is any of', 'is not'];
export const singleArrayOptions = ['is', 'is not'];
export const arrayOptions = ['is any of', 'is'];
export const textOptions = ['contains', 'does not contain'];
export const numberOptions = ['is equal to', 'is less than', 'is more than'];
export const numberRangeOptions = ['amount range is', 'amount range is not'];
export const signatureStatusOptions = ['signed by', 'not signed by', 'awaiting signature by'];

const formulaOptions = {
  text: [
    {
      label: 'is',
      value: 'is',
      children: [{ component: getFilterComponent('dropdown') }],
      type: 'list'
    },
    {
      label: 'is not',
      value: 'is not',
      children: [{ component: getFilterComponent('dropdown') }],
      type: 'list'
    },
    {
      label: 'contains',
      value: 'contains',
      clickable: true,
      type: 'text'
    },
    {
      label: 'does not contain',
      value: 'does not contain',
      clickable: true,
      type: 'text'
    }
  ],
  'date-range': [
    {
      label: 'is',
      value: 'is',
      children: [{ component: getFilterComponent('dateRange') }],
      type: 'date-range'
    },
    {
      label: 'is not',
      value: 'is not',
      children: [{ component: getFilterComponent('dateRange') }],
      type: 'date-range'
    }
  ],
  range: [
    { label: 'is equal to', value: 'is equal to', clickable: true, type: 'number' },
    { label: 'is less than', value: 'is less than', clickable: true, type: 'number' },
    { label: 'is more than', value: 'is more than', clickable: true, type: 'number' },
    { label: 'amount range is', value: 'amount range is', clickable: true, type: 'number-range' },
    {
      label: 'amount range is not',
      value: 'amount range is not',
      clickable: true,
      type: 'number-range'
    }
  ],
  number: [
    { label: 'is equal to', value: 'is equal to', clickable: true, type: 'number' },
    { label: 'is less than', value: 'is less than', clickable: true, type: 'number' },
    { label: 'is more than', value: 'is more than', clickable: true, type: 'number' }
  ],
  'number-range': [
    { label: 'amount range is', value: 'amount range is', clickable: true, type: 'number-range' },
    {
      label: 'amount range is not',
      value: 'amount range is not',
      clickable: true,
      type: 'number-range'
    }
  ],
  'signature-status': [
    {
      label: 'signed by',
      value: 'signed by',
      type: 'list',
      children: [{ component: getFilterComponent('dropdown') }]
    },
    {
      label: 'not signed by',
      value: 'not signed by',
      type: 'list',
      children: [{ component: getFilterComponent('dropdown') }]
    },
    {
      label: 'awaiting signature by',
      value: 'awaiting signature by',
      type: 'list',
      children: [{ component: getFilterComponent('dropdown') }]
    }
  ]
};

const NUMERIC_FORMULA_LABELS = {
  'amount range is': 'range is',
  'amount range is not': 'range is not'
};

export const getFormulaLabel = (formula, numeric) =>
  (numeric && NUMERIC_FORMULA_LABELS[formula]) || formula;

export const getFormulaOptions = (
  type = 'text',
  count = 1,
  values = {},
  allowed_operators,
  numeric
) => {
  let options = ia(allowed_operators)
    ? formulaOptions[type].filter((option) => allowed_operators.includes(option.value))
    : formulaOptions[type];

  if (numeric) {
    options = iaRa(options).map((option) => ({
      ...option,
      label: getFormulaLabel(option.value, numeric)
    }));
  }

  if (type === 'signature-status') {
    return options || [];
  }

  if (ia(values)) {
    if (count > 1) {
      options = iaRa(options).filter((option) => multipleArrayOptions.includes(option.value));
      options.unshift({
        label: 'is any of',
        value: 'is any of',
        type: 'list',
        children: [{ component: getFilterComponent('dropdown') }]
      });
    } else {
      options = iaRa(options).filter((option) => singleArrayOptions.includes(option.value));
    }
  }
  if (typeof values === 'string' && type === 'text') {
    options = iaRa(options).filter((option) => textOptions.includes(option.value));
  }
  if (type === 'range' || type === 'number-range' || type === 'number') {
    if (values?.from && values?.to) {
      options = iaRa(options).filter((option) => numberRangeOptions.includes(option.value));
    } else if (typeof values === 'string' || typeof values === 'number') {
      options = iaRa(options).filter((option) => numberOptions.includes(option.value));
    }
  }

  return options || [];
};

export const filterOptions = (searchTerm = '', options) => {
  return {
    options: options.filter((status) =>
      status.label.toLowerCase().includes(searchTerm.toLowerCase())
    )
  };
};

export const isDuplicateName = (name, currentViews, items, currentView) => {
  if (!name || typeof name !== 'string') return false;

  const nameLower = name.toLowerCase();

  const isDuplicateView = iaRa(currentViews).some(
    (view) =>
      typeof view.name === 'string' &&
      view.name.toLowerCase() === nameLower &&
      view.id !== currentView?.id
  );

  const isDuplicateItem = items.some(
    (item) => typeof item.value === 'string' && item.value.toLowerCase() === nameLower
  );

  return isDuplicateView || isDuplicateItem;
};
